export { SafeSidebarContent } from './SafeSidebarContent'
